module.exports = __webpack_public_path__ + "static/media/creative.4eba480f.svg";